import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import styled from "styled-components";
import RegistrationChart from "./charts/RegistrationChart";

const RegLogContainer = styled(Box)`
    background: white; padding: 20px; border-radius: 5px;
    display: flex; flex-direction: column; gap: 20px;
`;

const RegistrationLog = ({ registrationData }: any) => {

    return (
        <RegLogContainer>
            <Typography variant="h6" component="p" sx={{ fontWeight: 600 }}>Registrations</Typography>
            <Grid container spacing={2}>
                <Grid item xs={8}>
                    <RegistrationChart data={registrationData?.weeklyData} />
                </Grid>

                <Grid item xs={4}>
                    <GraphInfoSec data={registrationData} />
                </Grid>
            </Grid>
        </RegLogContainer>
    );
}

const GraphInfoSec = ({ data }: any) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", justifyContent: "center", alignItems: "start" }}>
            <Typography variant="h3" component="p" sx={{ color: "#F2994A" }}>{data?.totalWeekRegisters}</Typography>
            <Typography>New Registration last week</Typography>
        </Box>
    )
}


export default RegistrationLog;